import goalSelectStyles from "layouts/goals/components/goalSelectStyles";

export const ADMIN_USERS_COLUMNS = [
  { name: "user", align: "left" },
  { name: "role", align: "left" },
  { name: "teams", align: "left" },
  { name: "status", align: "center" },
  { name: "actions", align: "center" },
];

export const USER_MANAGEMENT_MESSAGES = {
  empty: "No users yet.",
  nameRequired: "Name is required.",
  emailRequired: "A valid email is required.",
  passwordRequired: "Password must be at least 8 characters.",
  roleRequired: "Select a role.",
  teamsRequired: "Select at least one team.",
  created: "User created successfully.",
  updated: "User updated successfully.",
  deleted: "User deleted successfully.",
};

// Goals dropdown look, plus a multi-select that matches it: the default grey
// square chips and dark clear icon clash with the rounded, cyan-accented inputs.
export const userSelectStyles = {
  ...goalSelectStyles,
  valueContainer: (base) => ({ ...base, padding: "2px 10px", gap: 4 }),
  multiValue: (base) => ({
    ...base,
    margin: 0,
    borderRadius: 12,
    backgroundColor: "#e0f5fb",
  }),
  multiValueLabel: (base) => ({
    ...base,
    padding: "2px 4px 2px 10px",
    fontSize: 12,
    fontWeight: 600,
    color: "#0b7c99",
  }),
  multiValueRemove: (base) => ({
    ...base,
    paddingRight: 6,
    borderRadius: "0 12px 12px 0",
    color: "#0b7c99",
    cursor: "pointer",
    "&:hover": { backgroundColor: "#17c1e8", color: "#fff" },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "#8392ab",
    cursor: "pointer",
    "&:hover": { color: "#c01616" },
  }),
};
